"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _commonTags = require("common-tags");

var _get2 = _interopRequireDefault(require("lodash/get"));

var _getTypes = _interopRequireDefault(require("@sift/runner/getTypes"));

var _Context = _interopRequireDefault(require("@sift/runner/Context"));

var _withErrorBoundary = _interopRequireDefault(require("@sift/runner/withErrorBoundary"));

var _getReadOnly = _interopRequireDefault(require("@sift/runner/getReadOnly"));

var _isField = _interopRequireDefault(require("@sift/runner/isField"));

var _isCategory = _interopRequireDefault(require("@sift/runner/isCategory"));

var _getHideIfEmpty = _interopRequireDefault(require("@sift/runner/getHideIfEmpty"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n          The value of 'isSection' has changed from one render to the next. Please ensure that this\n          does NOT happen. This may cause some hooks in your components to be called conditionally\n          which breaks the rules of hooks.\n        "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function getComponentRegistryToUse(node, mode, componentRegistry) {
  var configType = function () {
    if ((0, _isField.default)(node)) {
      return 'fields';
    }

    if ((0, _isCategory.default)(node)) {
      return 'categories';
    }

    return null;
  }();

  if (!configType) {
    throw new Error("[Runner] could not get config type for node \"".concat(node.id, "\""));
  }

  return (0, _get2.default)(componentRegistry, [configType, mode]);
}

function Runner(_ref) {
  var value = _ref.value,
      onChange = _ref.onChange,
      currentValue = _ref.currentValue,
      onCurrentChange = _ref.onCurrentChange,
      nodeFromProps = _ref.node,
      modeFromProps = _ref.mode,
      componentRegistryFromProps = _ref.componentRegistry,
      configFromProps = _ref.config,
      rootFromProps = _ref.root,
      itemIndex = _ref.itemIndex,
      isSection = _ref.isSection,
      isEditorFromProps = _ref.isEditor,
      rest = _objectWithoutProperties(_ref, ["value", "onChange", "currentValue", "onCurrentChange", "node", "mode", "componentRegistry", "config", "root", "itemIndex", "isSection", "isEditor"]);

  var contextValue = (0, _react.useContext)(_Context.default);
  var nodeFromContext = contextValue && contextValue.node;
  var componentRegistryFromContext = contextValue && contextValue.componentRegistry;
  var configFromContext = contextValue && contextValue.config;
  var rootFromContext = contextValue && contextValue.root;
  var modeFromContext = contextValue && contextValue.mode;
  var isEditorFromContext = contextValue && contextValue.isEditor;
  var node = nodeFromProps || nodeFromContext;
  var config = configFromProps || configFromContext;
  var root = rootFromProps || rootFromContext;
  var mode = modeFromProps || modeFromContext;
  var componentRegistry = componentRegistryFromProps || componentRegistryFromContext;
  var isItem = itemIndex !== undefined;
  var isEditor = !!(isEditorFromProps !== undefined ? isEditorFromProps : isEditorFromContext);

  if (!componentRegistry) {
    throw new Error('[Runner] could not find `componentRegistry` from props or from context');
  }

  if (!config) {
    throw new Error('[Runner] could not find `config` from props or from context');
  }

  if (!root) {
    throw new Error('[Runner] could not find `root` from props or from context');
  }

  if (!mode) {
    throw new Error('[Runner] could not find `mode` from props or from context');
  }

  if (!node) {
    throw new Error('[Runner] could not find `node` from props or from context');
  } // ---
  // find the correct component key
  // ---


  var componentKeys = (0, _getTypes.default)(node, mode);
  var componentRegistryToUse = getComponentRegistryToUse(node, mode, componentRegistry);
  var componentKey = componentKeys.find(function (key) {
    return !!componentRegistryToUse[key];
  }); // ---
  // ensure there is a component to render defaulting to the component at the key
  // `[defaultComponentKey]`
  // ---

  if (!componentKey && !(0, _isCategory.default)(node)) {
    throw new Error("[Runner] could not find any components for type(s) \"".concat(componentKeys.join(', '), "\" for mode \"").concat(mode, "\" for node \"").concat(node.id, "\""));
  }

  var Component = componentRegistryToUse[componentKey || 'enumerator']; // ---
  // gets the correct subvalue. if it's a `category`, the subvalue will be the whole value
  // if it's a `field`, the subvalue will reach into the object using the field's `objectKey`
  // ---

  var componentValue = (0, _react.useMemo)(function () {
    // if there is a `onCurrentChange` then that means we should use `currentValue` instead of'
    // `value`
    if (onCurrentChange) {
      return currentValue;
    }

    if ((0, _isCategory.default)(node)) {
      return value;
    }

    var objectKey = node.objectKey; // if this is an item then we should drill deeper on the itemIndex

    if (itemIndex !== undefined) {
      return (0, _get2.default)(value, [itemIndex]);
    } // otherwise return a subvalue


    var objectKeySplit = objectKey.split('.');
    var subvalueKey = objectKeySplit[objectKeySplit.length - 1];
    return (0, _get2.default)(value, [subvalueKey]);
  }, [node, value, itemIndex, onCurrentChange, currentValue]); // this ref is used to preserve the memoization of `handleChange` below

  var valueRef = (0, _react.useRef)(value);
  (0, _react.useLayoutEffect)(function () {
    valueRef.current = value;
  }, [value]);
  var handleChange = (0, _react.useMemo)(function () {
    if (onCurrentChange) {
      return onCurrentChange;
    }

    if (!onChange) {
      throw new Error("[Runner] expected \"onChange\" to have been defined. Check the runner call for node \"".concat(node.id, "\""));
    } // `objectKeys` are only available on fields


    var objectKey = (0, _get2.default)(node, ['objectKey']); // it must be a category if there is no `objectKey` so return the parent `onChange` handler

    if (!objectKey) {
      return onChange;
    } // otherwise, it must be a field so return a handler that uses the sub-key


    var objectKeySplit = objectKey.split('.');
    var subvalueKey = objectKeySplit[objectKeySplit.length - 1]; // if it's an item then use the `itemIndex` to propagate the change correctly

    if (itemIndex !== undefined) {
      return function (newValue) {
        var value = valueRef.current;
        onChange([].concat(_toConsumableArray(value.slice(0, itemIndex)), [newValue], _toConsumableArray(value.slice(itemIndex + 1, value.length))));
      };
    }

    return function (newValue) {
      var value = valueRef.current;
      onChange(_objectSpread({}, value, _defineProperty({}, subvalueKey, newValue)));
    };
  }, [node, onChange, onCurrentChange]); // ---
  // grabs the options at the `layoutObject.display` or `layoutObject.input`
  // ---

  var options = (0, _get2.default)(node, [mode]);
  var nextContextValue = (0, _react.useMemo)(function () {
    return {
      config: config,
      componentRegistry: componentRegistry,
      node: node,
      mode: mode,
      root: root,
      isEditor: isEditor
    };
  }, [config, componentRegistry, node, mode, root, isEditor]);
  var readOnly = (0, _react.useMemo)(function () {
    return (0, _getReadOnly.default)(node, config);
  }, [node, config]);
  var hideIfEmpty = (0, _getHideIfEmpty.default)({
    isEditor: isEditor,
    node: node,
    readOnly: readOnly
  });

  if (process.env.NODE_ENV !== 'production') {
    var previousIsSection = (0, _react.useRef)(isSection);
    (0, _react.useEffect)(function () {
      if (previousIsSection.current !== isSection) {
        console.warn((0, _commonTags.oneLine)(_templateObject()));
      }
    }, [isSection]);
  } // ---
  // create the Input component
  // ---


  var Input = (0, _react.useMemo)(function () {
    if (mode === 'input') {
      return function () {
        throw new Error('[Runner] cannot call `props.Input` within an input component');
      };
    }

    return function Input(_ref2) {
      var onChange = _ref2.onChange,
          value = _ref2.value,
          rest = _objectWithoutProperties(_ref2, ["onChange", "value"]);

      // ---
      // find the correct component key
      // ---
      var componentKeys = (0, _getTypes.default)(node, 'input');
      var inputComponentRegistry = getComponentRegistryToUse(node, 'input', componentRegistry);
      var componentKey = componentKeys.find(function (key) {
        return !!inputComponentRegistry[key];
      }); // ---
      // ensure there is a component to render
      // ---

      if (!componentKey && !(0, _isCategory.default)(node)) {
        throw new Error("[Runner] could not find any components for type(s) \"".concat(componentKeys.join(', '), "\" for mode \"input\" for node \"").concat(node.id, "\""));
      }

      var Component = inputComponentRegistry[componentKey || 'enumerator'];
      var nextInputContextValue = (0, _react.useMemo)(function () {
        return _objectSpread({}, nextContextValue, {
          mode: 'input'
        });
      }, [nextContextValue]);
      return _react.default.createElement(_Context.default.Provider, {
        value: nextInputContextValue
      }, _react.default.createElement(Component, _extends({
        config: config,
        componentRegistry: componentRegistry,
        root: root,
        value: value,
        options: options,
        onChange: onChange,
        node: node,
        mode: "input",
        isItem: isItem,
        readOnly: readOnly,
        Input: Input,
        isSection: false,
        isEditor: isEditor,
        hideIfEmpty: hideIfEmpty
      }, rest)));
    };
  }, [node, config, componentRegistry, root, options, onChange, mode, isItem, readOnly, isEditor]); // ---
  // call the final component
  // ---

  return _react.default.createElement(_Context.default.Provider, {
    value: nextContextValue
  }, _react.default.createElement(Component, _extends({
    config: config,
    componentRegistry: componentRegistry,
    root: root,
    value: componentValue,
    options: options,
    onChange: handleChange,
    node: node,
    mode: mode,
    isItem: isItem,
    readOnly: readOnly,
    Input: Input,
    isSection: !!isSection,
    isEditor: isEditor,
    hideIfEmpty: hideIfEmpty
  }, rest)));
}

var _default = (0, _react.memo)((0, _withErrorBoundary.default)(Runner));

exports.default = _default;